import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface AddSubtypeVersionRequest {
  subtype_id: number;
  valid_from: string;
  valid_to?: string | null;
  descriptions?: Record<string, { language_code: string; translation_text: string }>;
}

export function addSubtypeVersion(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'AddSubtypeVersion',
    description: 'Adds a new version to an existing subtype',
    execute: (data: AddSubtypeVersionRequest): Observable<any> => {
      if (!data.subtype_id || !data.valid_from) {
        return of({ success: false, error: 'Missing required fields: subtype_id, valid_from' });
      }
      const payload: Record<string, unknown> = {
        valid_from: data.valid_from,
        valid_to: data.valid_to && String(data.valid_to).trim() !== '' ? data.valid_to : null
      };
      if (data.descriptions && Object.keys(data.descriptions).length > 0) {
        payload['descriptions'] = data.descriptions;
      }
      return componentDataSourceService.http.post<unknown>(
        `${environment.apiUrl}/events/subtypes/${data.subtype_id}/versions`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      ).pipe(
        tap(() => {
          dataSharingService.setData('subtypes_updated', { timestamp: Date.now(), subtype_id: data.subtype_id });
        }),
        catchError(err => {
          console.error('[AddSubtypeVersion] Error:', err);
          throw err;
        })
      );
    }
  };
}
